import * as React from 'react';
import { Logo } from '@components/Logo/Logo';
import { Menu } from '@components/Menu/Menu';
import { TopbarWrapper, TopbarContent, LogoContainer } from './Topbar.s';
import { topbarHeight } from '@styles/layout';
import { discoverPath } from '@config/paths';
import { Location } from 'history';
import { mobileBreakpoint } from '@styles/layout';

type TopbarProps = {
  location: Location;
  discoverPosition: number;
  explainPosition: number;
  aboutPosition: number;
  windowHeight: number;
  windowWidth: number;
};

export const Topbar = (props: TopbarProps) => (
  (props.windowWidth >= mobileBreakpoint) ? (
    <TopbarWrapper>
      <TopbarContent>
        <LogoContainer to={discoverPath.compile()}>
          <Logo height={topbarHeight} width={100} />
        </LogoContainer>
        <Menu {...props} />
      </TopbarContent>
    </TopbarWrapper>
  ) : (
    null
  )
);


// WEBPACK FOOTER //
// src/app/src/components/Topbar/Topbar.tsx